import React from 'react';
import styled from 'styled-components';
import NavSelect from 'shared/components/NavSelect';
import NavButtons, { NavButton } from 'shared/components/NavButtons';
import { Row, RowSpaceBetween } from 'shared/components/styled';
import SearchInput from 'shared/components/SearchInput';

const groupByOptions = [
  { value: 'by-due-date', label: 'Due date' },
  { value: 'by-donor', label: 'Donor' },
  { value: 'by-manager', label: 'Manager' },
  { value: 'by-program', label: 'Program' },
];

export default function Grouping({ children, count, handleSearchInput=() => { /* noop */ }, filter = ''}) {
  return (<>
    <RowSpaceBetween className="screen-group">
      <h2>Tasks <span>({count})</span></h2>
      <div className="row">
        <SearchInput
          style={{minWidth: 200}}
          onInput={handleSearchInput}
          filter={filter}
        />
        <span className="input-title">Group by:</span>
        <NavSelect
          name=":3"
          hasCheckbox={false}
          options={groupByOptions}
          minWidth={200}
        />
        {children}
      </div>
    </RowSpaceBetween>
  </>);
}
/*
const titleConfig = {
  group: {
    'by-due-date': 'Grouped by Due Date',
    'by-program': 'Grouped by Program',
    'by-donor': 'Grouped by Donor',
    'by-manager': 'Grouped by Program Manager',
  },
  filter(values) {
    const names = {
      'my-tasks': 'My Tasks',
    }
    const filters = Object.keys(names)
      .filter(key => values[key])
      .map(key => names[key])

    return filters.length
      ? ` (${filters.join(', ')})`
      : ''
  }
}
*/
const Label = styled.span`
  margin-right: 10px
`;

const Root = styled(Row)`
  min-width: 410px;
`;